import store from '@/store'

const createGlobalSuccessNotification = notification => {
  store.dispatch('setNotification', notification)

  setTimeout(() => {
    store.dispatch('clearNotification')
  }, 3000)
}

const createGlobalSuccessQuickNotification = message => {
  createGlobalSuccessNotification({
    notification: {
      type: 'success',
      content: message
    }
  })
}

export default {
  createGlobalSuccessNotification,
  createGlobalSuccessQuickNotification
}
